// load appropriate dotenv file
require('dotenv').config({
  path: `.env.${process.env.NODE_ENV}`,
  quiet: true,
})

const defaultHost = `http://localhost:8000`

const dataPath = process.env.DATA_PATH || `${__dirname}/../data`

module.exports = {
  siteMetadata: {
    siteUrl: process.env.GATSBY_SITE_URL || defaultHost,
    apiHost: process.env.GATSBY_API_HOST || defaultHost,
    title: `Community Heat Resilience Tool`,
    shortTitle: `CHaRT`,
    description: `A tool to help explore heat health risks and interventions.`,
    author: `University of Washington, Center for Health and the Global Environment`,
    googleAnalyticsId: process.env.GATSBY_GOOGLE_ANALYTICS_ID,
    sentryDSN: process.env.GATSBY_SENTRY_DSN,
    contactEmail: `heathealth@uw.edu`,
  },
  flags: {
    FAST_DEV: false,
    DEV_SSR: true,
  },
  plugins: [
    {
      resolve: `gatsby-plugin-google-gtag`,
      options: {
        trackingIds: process.env.GATSBY_GOOGLE_ANALYTICS_ID
          ? [process.env.GATSBY_GOOGLE_ANALYTICS_ID]
          : [],
        gtagConfig: {
          anonymize_ip: true,
        },
        pluginConfig: {
          head: true,
          respectDNT: true,
        },
      },
    },
    {
      resolve: `gatsby-plugin-theme-ui`,
      options: {
        injectColorFlashScript: false,
      },
    },
    `gatsby-plugin-image`,
    `gatsby-transformer-sharp`,
    `gatsby-plugin-sharp`,
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `images`,
        path: `${__dirname}/src/images/`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `tiles`,
        path: `${dataPath}/tiles`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `interventions`,
        path: `${__dirname}/../interventions`,
      },
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `models`,
        path: `${dataPath}/models`,
      },
    },
    {
      resolve: `gatsby-transformer-remark`,
      options: {
        plugins: [
          {
            resolve: `gatsby-remark-images`,
            options: {
              maxWidth: 1200,
            },
          },
          {
            resolve: `process-markdown`,
            options: {
              tocHeadingDepth: 3,
            },
          },
        ],
      },
    },
    `gatsby-plugin-catch-links`,
    `gatsby-plugin-sitemap`,
    {
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: process.env.GATSBY_SITE_URL || defaultHost,
      },
    },
  ],
}
